import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PageNotFoundService } from '../../shared/page-not-found.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit, OnDestroy {
  constructor(
    private readonly pageNotFoundService: PageNotFoundService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.pageNotFoundService.setPageNotFound();
  }

  navigateToHome() {
    this.router.navigate(['/home/stream-view']);
  }

  ngOnDestroy() {
    this.pageNotFoundService.resetPageNotFound();
  }
}
